const currencyFormatter = new Intl.NumberFormat('de-AT', {
  style: 'currency',
  currency: 'EUR',
})

const dateFormatter = new Intl.DateTimeFormat('de-AT', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

const datetimeFormatter = new Intl.DateTimeFormat('de-AT', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
})

export function formatCurrency(cents: number): string {
  return currencyFormatter.format(cents / 100)
}

export function formatDate(iso: string | Date): string {
  return dateFormatter.format(typeof iso === 'string' ? new Date(iso) : iso)
}

export function formatDatetime(iso: string | Date): string {
  return datetimeFormatter.format(typeof iso === 'string' ? new Date(iso) : iso)
}

export function formatNumber(n: number): string {
  return new Intl.NumberFormat('de-AT').format(n)
}

export function formatYearMonth(key: string): string {
  const [year, month] = key.split('-')
  const date = new Date(Number(year), Number(month) - 1)
  return new Intl.DateTimeFormat('de-AT', {
    year: 'numeric',
    month: 'long',
  }).format(date)
}

export function formatGroupKey(groupBy: string, key: string): string | null {
  switch (groupBy) {
    case 'year':
      return key
    case 'quarter':
      return key
    case 'month':
      return formatYearMonth(key)
    case 'week': {
      const m = key.match(/^(\d{4})-W(\d{2})$/)
      return m ? `KW ${m[2]}, ${m[1]}` : key
    }
    case 'day':
      return formatDate(key)
    default:
      return null
  }
}

const viennaParts = new Intl.DateTimeFormat('de-AT', {
  timeZone: 'Europe/Vienna',
  weekday: 'short',
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
})

function viennaPart(parts: Array<Intl.DateTimeFormatPart>, type: string) {
  return parts.find((p) => p.type === type)?.value ?? ''
}

/** "17.09. 14:05" — one end of a Tagesabschluss window, in Vienna time. */
export function formatShortDateTime(iso: string): string {
  const parts = viennaParts.formatToParts(new Date(iso))
  return `${viennaPart(parts, 'day')}.${viennaPart(parts, 'month')}. ${viennaPart(parts, 'hour')}:${viennaPart(parts, 'minute')}`
}

/** "Mo 21.09. 14:12" — when a Tagesabschluss was closed, in Vienna time. */
export function formatWeekdayDateTime(iso: string): string {
  const parts = viennaParts.formatToParts(new Date(iso))
  const weekday = viennaPart(parts, 'weekday').replace(/\.$/, '')
  return `${weekday} ${formatShortDateTime(iso)}`
}
